import {isDefined, safeSplit} from "../utils/epic.utils";

export class MediaType {

  public static readonly PDF: string = 'application/pdf';
  public static readonly XML: string = 'text/xml';
  public static readonly CSV: string = 'text/csv';
  public static readonly TEXT: string = "text/plain";
  public static readonly TIF: string = 'image/tif';
  public static readonly TIFF: string = 'image/tiff';
  public static readonly JPG: string = 'image/jpg';
  public static readonly JPEG: string = 'image/jpeg';
  public static readonly PNG: string = 'image/png';
  public static readonly IMAGES: string[] = [MediaType.JPG, MediaType.JPEG, MediaType.PNG, MediaType.TIF, MediaType.TIFF];
  // Images supported by the browser for display
  public static readonly BROWSER_IMAGES: string[] = [MediaType.JPG, MediaType.JPEG, MediaType.PNG];

  private readonly types: Set<string>;

  constructor(types?: string | string[]) {
    if (Array.isArray(types)) {
      this.types = new Set(types);
    } else if (isDefined(types)) {
      this.types = new Set([types]);
    } else {
      this.types = new Set();
    }
  }

  public static all(): MediaType {
    return new MediaType().withImages().withPdf().withXml().withCsv().withText();
  }

  public static create(types?: string | string[]): MediaType {
    return new MediaType(types);
  }

  public static pdf(): MediaType {
    return new MediaType(MediaType.PDF);
  }

  public withImages(): MediaType {
    MediaType.IMAGES.forEach((t) => this.types.add(t));
    return this;
  }

  public withPdf(): MediaType {
    this.types.add(MediaType.PDF);
    return this;
  }

  public withXml(): MediaType {
    this.types.add(MediaType.XML);
    return this;
  }

  public withCsv(): MediaType {
    this.types.add(MediaType.CSV);
    return this;
  }

  public withText(): MediaType {
    this.types.add(MediaType.TEXT);
    return this;
  }

  public add(type: string): MediaType {
    this.types.add(type);
    return this;
  }

  public getTypes(): Set<string> {
    return new Set(this.types);
  }

  public asArray(): string[] {
    return Array.from(this.getTypes());
  }

  public toString(): string {
    return this.asArray().join(', ');
  }

  public includes(type: string): boolean {
    return this.asArray().includes(type);
  }

  public asExtensions(): string[] {
    return this.asArray()
      .map((t) => {
        const parts: string[] = safeSplit(t, '/');
        let ext: string = parts[parts.length - 1].toUpperCase();
        if (ext === 'JPEG') {
          ext = 'JPG';
        } else if (ext === 'TIF') {
          ext = 'TIFF';
        } else if (ext === 'TEXT' || ext === 'PLAIN') {
          ext = 'TXT';
        }
        return ext;
      })
      .filter((value, index, self) => self.indexOf(value) === index);
  }
}
